import makeStyles from "@mui/styles/makeStyles";
import { grey100 } from "../other/helper/MuiStyles";

export const useStyles = makeStyles(() => ({
    banner: {
        height: '80px',
        backgroundColor: '#FFF',
        borderTop: `1px solid ${grey100}`
    },
}));